import {FeatureCollection, Point, Polygon} from 'geojson';
import {CancelablePromise} from '@zvne/fe-framework/dist/data-access/generic-types';
import {axiosToCancelablePromise} from './reusable/axios-to-cencelable-promise';
import {mapCancelablePromise} from '@zvne/fe-framework/dist/data-access/map-cencelable-promise';
import {configuration} from '../config/configuration';
import {axios} from './reusable/axios';

export interface ClusterHistory {
    startTimestamp: Date;
    durationMinutes: number;
    intervalSizeMinutes: number;
    intervals: Map<number, ClusterHistoryInterval>;
}

export interface ClusterHistoryInterval {
    polygons: FeatureCollection<Polygon, ClusterHistoryProperties>;
    centroids: FeatureCollection<Point, ClusterHistoryProperties>
}

export interface ClusterHistoryProperties {
    prediction: number;
    clusterId: number;
    strokeCount: number;
    centroidX: number;
    centroidY: number;
}

export interface ClusterHistoryParams {
    startTimestamp: Date;
    durationMinutes: number;
}

interface Response {
    startTimestamp: string;
    durationMinutes: number;
    intervalSizeMinutes: number;
    intervals: Record<string, ClusterHistoryInterval>;
}

export function getClusterHistory(params: ClusterHistoryParams): CancelablePromise<ClusterHistory> {
    return mapCancelablePromise(
        axiosToCancelablePromise(cancelToken => axios.get<Response>(
            configuration.apiRoot + '/cluster-history',
            {cancelToken: cancelToken, params: params}
        )),
        response => ({
            ...response,
            startTimestamp: new Date(response.startTimestamp),
            intervals: new Map(
                Object.entries(response.intervals).map(
                    ([dateString, interval]) => [(new Date(dateString)).valueOf(), interval]
                )
            )
        })
    );
}
